/**
 * DemoBanner — Top-of-page banner shown during demo mode.
 *
 * Dismissible per session via sessionStorage. Reappears next session.
 * Pattern mirrors TrialUrgencyBanner.tsx.
 */

import { useState } from "react"
import { Link } from "react-router"
import { Sparkles, X, ArrowRight } from "lucide-react"
import { Button } from "@/components/ui/button"

export function DemoBanner() {
  const storageKey = "demoBannerDismissed"
  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem(storageKey) === "true"
    } catch {
      return false
    }
  })

  if (dismissed) return null

  const handleDismiss = () => {
    try {
      sessionStorage.setItem(storageKey, "true")
    } catch {
      // sessionStorage unavailable
    }
    setDismissed(true)
  }

  return (
    <div className="bg-primary/10 border border-primary/20 rounded-lg px-4 py-3 mx-8 mt-4 mb-0">
      <div className="flex items-start gap-3">
        <Sparkles className="h-4 w-4 text-primary mt-0.5 flex-shrink-0" />
        <div className="flex-1">
          <p className="text-sm font-medium text-foreground">
            You're exploring the Villa Seaview demo
          </p>
          <p className="text-xs text-muted-foreground mt-0.5">
            Connect your own property to unlock all features with real data.
          </p>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <Button size="sm" asChild>
            <Link to="/onboarding">
              Connect Property
              <ArrowRight className="h-3.5 w-3.5 ml-1.5" />
            </Link>
          </Button>
          <Button size="sm" variant="ghost" onClick={handleDismiss}>
            <X className="h-3.5 w-3.5" />
          </Button>
        </div>
      </div>
    </div>
  )
}
